module.exports = __webpack_public_path__ + "img/logo.d3c89a86.svg";